var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"loader loader-7"},[_c('div',{staticClass:"line line1"}),_c('div',{staticClass:"line line2"}),_c('div',{staticClass:"line line3"})])])
}]

export { render, staticRenderFns }